import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { GegeAction, GegeActions } from '../gegeActions';

export function* watchAntragsnummerRequested(): SagaIterator {
  yield takeEvery(
    GlobalActions.ANTRAGSNUMMER_REQUESTED,
    safeSaga(antragsnummerRequested, App.GEGE),
  );
  yield takeEvery(GegeActions.VORSCHLAGDATEN_CHANGED, safeSaga(vorschlagsDatenChanged, App.GEGE));
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.GEGE),
  );
}

export function* antragsnummerRequested(action: GlobalAction<AngebotsId>): SagaIterator {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;
  const { appId, angebotsId } = action.payload;

  if (appId === App.GEGE && angebotsId === angebotsIdInStore) {
    return yield call(antragsnummerSaga, angebotsIdInStore);
  }
}

export function* vorschlagsDatenChanged(action: GegeAction<string>): SagaIterator {
  yield call(antragsnummerSaga, action.payload);
}

export function* antragsnummerSaga(angebotsId: string): SagaIterator {
  const globalPut = GlobalPut.getInstance();

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequestAntragsnummer(
      App.GEGE,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      angebotsId,
    ),
  );
}

export function* successCallback(successAction: DoRequestResponse<string>): SagaIterator {
  try {
    if (successAction.doRequestAction.payload.appId === App.GEGE) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(
        new GegeActions().antragsnummerGenerated(
          antragsnummerAsString,
          successAction.doRequestAction.payload.angebotsId,
        ),
      );
      yield call(globalPut.put, new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.GEGE,
      exception as Error,
      'AntragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
